import React from 'react'

export const IconGlitter = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="15" height="14" viewBox="0 0 15 14" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3182 2.94322C11.5934 2.66813 11.7814 2.18718 11.875 1.75C11.9685 2.18721 12.157 2.66816 12.432 2.94304C12.7071 3.21813 13.1881 3.40628 13.6251 3.49973C13.1881 3.59352 12.7071 3.78172 12.4322 4.05678C12.157 4.33204 11.9689 4.81259 11.8754 5.25C11.7817 4.81259 11.5934 4.33202 11.3182 4.05696C11.0431 3.78169 10.5623 3.5939 10.1251 3.50009C10.5623 3.40648 11.0431 3.21811 11.3182 2.94322ZM7.49997 2.39301C7.76708 3.64289 8.30531 5.01658 9.09167 5.80323C9.87832 6.58962 11.2522 7.12782 12.502 7.39493C11.2524 7.66258 9.87829 8.20056 9.09193 8.98692C8.30569 9.77357 7.76762 11.1475 7.50051 12.3977C7.23299 11.1478 6.69476 9.77382 5.9084 8.98746C5.12204 8.20078 3.74818 7.66287 2.49805 7.39576C3.74767 7.12811 5.12178 6.58987 5.90814 5.80377C6.69479 5.01712 7.23245 3.64314 7.49997 2.39301Z"
      fill="currentColor"
    />
  </svg>
)
